import {DetailsTabContentWrapper} from '@/features/projects/components/details-tab-content-wrapper/DetailsTabContentWrapper'
import {useTranslation} from '@/translations/i18n'
import {Helmet} from 'react-helmet'
import {useOutletContext} from 'react-router-dom'
import {ProjectExtended} from '@/features/projects/types'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {PlannedAccessSection} from '@/features/projects/components/planned-access-section/PlannedAccessSection'
import {AccessesSection} from '@/features/projects/components/accesses-section /AccessesSection'
import {StyledProjectDetailsAccessAbsenceContainer} from './style'
import {AccessesCounterCard} from '@/features/projects/components/accesses-counter-card/AccessesCounterCard'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {PlannedAccessCounterCard} from '@/features/projects/components/planned-access-counter-card/PlannedAccessCounterCard'
import {AbsencesCard} from '@/features/projects/components/absences-card/AbsencesCard'
import {usePermissions} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'

export const ProjectDetailsAccessAbsence = () => {
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const {t} = useTranslation()
    const permissions = usePermissions()

    if (!permissions?.projects?.read) {
        return <NoPermissionBox />
    }

    return (
        <ScrollArea scrollbar={<Scrollbar />}>
            <DetailsTabContentWrapper>
                <Helmet title={t('commons:fullname_details_meta_title', {fullName: project.patient.fullName})} />
                <StyledProjectDetailsAccessAbsenceContainer>
                    <Grid columns={2} gap={2} fullWidth style={{height: '100%'}}>
                        <PlannedAccessCounterCard />
                        <AbsencesCard />
                    </Grid>
                    <AccessesCounterCard />

                    <PlannedAccessSection />

                    <AccessesSection />
                </StyledProjectDetailsAccessAbsenceContainer>
            </DetailsTabContentWrapper>
        </ScrollArea>
    )
}
